import { render, staticRenderFns } from "./SalesByCustomerStat.vue?vue&type=template&id=b9ff82e4&scoped=true&"
import script from "./SalesByCustomerStat.vue?vue&type=script&lang=js&"
export * from "./SalesByCustomerStat.vue?vue&type=script&lang=js&"
import style0 from "./SalesByCustomerStat.vue?vue&type=style&index=0&id=b9ff82e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ff82e4",
  null
  
)

export default component.exports
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QLayout,QPageContainer,QBtn,QTable,QTd,QTooltip,QChip,QToggle,QIcon});
